import { usaStates } from "../../components/ui/forms/selectOptionData";

/**
 * Convert a state value (either full name or code) to its 2-letter code.
 * Handles both uppercase and lowercase inputs.
 * Supports both single strings and arrays of states.
 * 
 * @param {string|Array} stateValue - State full name (e.g., "Alaska", "ALASKA") or code (e.g., "AK", "ak"), or array of states
 * @returns {string|Array|null} - State code in lowercase (e.g., "ak") or array of codes, or null if not found
 */
export function fromStateNameToCode(stateValue) {
  // Handle null/undefined
  if (!stateValue) {
    return stateValue;
  }

  // Handle arrays
  if (Array.isArray(stateValue)) {
    return stateValue
      .map((state) => fromStateNameToCode(state))
      .filter((code) => code !== null);
  }

  // Handle non-string values
  if (typeof stateValue !== "string") {
    return null;
  }

  const normalized = stateValue.trim().toLowerCase();

  // Get all states
  const states = usaStates();

  // Check if it's a 2-letter code
  if (normalized.length === 2) {
    const found = states.find((s) => s.value.toLowerCase() === normalized);
    return found ? normalized : null;
  }

  // Try to find by full name
  const foundByName = states.find((s) => s.label.toLowerCase() === normalized);
  if (foundByName) {
    return foundByName.value.toLowerCase();
  }

  return null;
}
